<div class="box" (click)="toggleMenu()">
  <div class="btn" [ngClass]="isOpen ? 'active':'not-active'">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
